<template>
  <div class="bpa-search-container">
    <div class="search-input">
      <input type="text" v-model="search" placeholder="Type to begin search..." ref="search" @keyup="triggerSearch" @keyup.enter.native="selectKeyword(search)" />
      <i class="fa-solid fa-magnifying-glass" @click="selectKeyword(search)"></i>
      <transition name="fade" appear>
        <div class="search-results-container" :class="search.length <= 2 ? 'no-min-char' : ''" v-if="search.length > 0 && isOpen">
          <div class="spinner" role="progressbar" v-if="openSearch || search.length <= 2" style="position: absolute; width: 0px; z-index: 2000000000; left: 50%; top: 50%; transform: scale(1);">
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(0deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -1s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(30deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.916667s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(60deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.833333s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(90deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.75s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(120deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.666667s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(150deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.583333s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(180deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.5s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(210deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.416667s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(240deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.333333s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(270deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.25s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(300deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.166667s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
            <div style="position: absolute; top: -1.5px; width: 11px; height: 3px; background: transparent; border-radius: 1.5px; transform-origin: left center; transform: rotate(330deg) translateX(8px);">
              <div style="width: 100%; height: 100%; background: rgb(66, 66, 66); border-radius: 1.5px; box-shadow: transparent 0px 0px 1px; animation: 1s linear -0.0833333s infinite normal none running searchwp-spinner-line-fade-quick;">
              </div>
            </div>
          </div>

          <ul class="search-results" v-if="watched_keywords.length && search.length > 2">
            <li v-for="keyword in watched_keywords" @click="selectKeyword(keyword.text)"> {{ keyword.text }}</li>
          </ul>

          <div class="search-no-results" v-if="!watched_keywords.length && search.length > 2"><em>No Result Found</em></div>
        </div>
      </transition>
    </div>
    <transition name="fade" appear>
      <div class="search-close-container" v-if="search.length" @click="removeKeyword">
        <i class="fa-regular fa-circle-xmark fa-lg" id="search_form_close"></i>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    keywords: {
      type: Array,
      required: true
    },
    openSearch: {
      type: Boolean,
      default: false
    },
    keyword: String
  },
  data () {
    return {
      isOpen: false,
      search: '',
      watched_keywords: []
    }
  },
  methods: {
    triggerSearch ( e ) {
      this.isOpen = true
      if ( 2 >= this.search.length ) {
        return false
      }

      this.$emit( 'triggerKeywordSearch', this.search )
    },

    selectKeyword ( keyword ) {
      this.isOpen = false
      this.search = keyword
      this.$emit( 'triggerSearchSelect', this.search )
    },

    removeKeyword () {
      this.isOpen = false
      this.search = ''
      this.$emit( 'triggerSearchSelect', this.search )
    }
  },
  mounted () {
    let urlParams = new URLSearchParams( window.location.search )

    if ( urlParams.has( 'keyword' ) ) {
      this.search = urlParams.get( 'keyword' )
    }

  },
  watch: {
    keywords: function ( value ) {
      this.watched_keywords = [ { id: this.search, text: this.search }, ...value ]
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.bpa-search-container {
  width: 62%;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;

  @include xl {
    width: calc(100% - 16px);
    margin-bottom: 32px;
  }

  .search-input {
    position: relative;
    width: 100%;

    input {
      width: 100%;
      height: 50px;
      padding-left: 26px;
      font-weight: 500;
      font-size: 18px;
      font-family: Paralucent;
      color: rgba(7, 54, 83, 1);
      background-color: #F5F5F5;
      border: none;
      border-radius: 25px;

      &::placeholder {
        color: rgba(7, 54, 83, 0.45);
      }
    }

    .fa-magnifying-glass {
      color: #073653;
      position: absolute;
      right: 24px;
      top: 15px;
      cursor: pointer;
    }
  }

  .search-close-container {
    margin-left: 25px;
    cursor: pointer;
  }

  .search-results-container {
    position: absolute;
    left: 0;
    top: 70px;
    background: #ffffff;
    border-radius: 10px !important;
    box-shadow: none;
    filter: drop-shadow(0 3px 10px rgba(0, 0, 0, 0.16)) !important;
    min-height: 175px;
    max-height: 300px;
    width: 100%;
    overflow-y: scroll;
    z-index: 2;

    &.no-min-char::after {
      content: "Continue typing";
      display: block;
      text-align: center;
      padding: 2em 2em 0;
    }

    .search-results {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin: 0;
      padding: 12px;

      li {
        padding: 12px 16px;
        font-size: 18px;
        border-bottom: none;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;

        &:hover {
          background-color: #f0ede9;
          border-radius: 5px;
        }
      }
    }

    .search-no-results {
      padding: 3em 2em 0;
      text-align: center;
      color: #073653;
    }
  }
}
</style>